import { useEffect, useState } from "react";
import VideoCall from "./call/video-call";
import { Resizable } from 'react-resizable';
import { useAppDispatch, useAppSelector } from "../../../common/store";
import { Popup } from "../../components/pop-up";
import { endCall } from "../../../common/store/calls/calls-slice";
import ModalContainer, { WindowControl, WindowControlBottom } from "./styles";
import Video, { Room } from "twilio-video";
import Draggable from "react-draggable";
// import { ResizableBox } from 'resact-resizable';

const ChatCall = () => {
  const token = useAppSelector(state => state.calls.token);
  const roomName = useAppSelector(state => state.calls.room);
  const isOnCall = useAppSelector(state => state.calls.isOnCall);
  const isMicOn = useAppSelector(state => state.calls.isMicOn);
  const agentName = useAppSelector(state => state.calls.agentName);
  const agentPhotoURL = useAppSelector(state => state.calls.agentPhotoURL);
  const isCameraOn = useAppSelector(state => state.calls.isCameraOn);
  const [room, setRoom] = useState<Room | null>(null);
  const [containerSize, setContainerSize] = useState({ width: 200, height: 200 });

  const onResize = (event: any, { size }: {size: { width: number, height: number }}) => {
    setContainerSize({ width: size.width, height: size.height });
  };
  
  useEffect(() => {
    const connectToRoom = async () => {
      const room = await Video.connect(token, {
        name: roomName,
        video: false,
      });
      setRoom(room);
    };

    if (token && isOnCall) {
      connectToRoom();
    }
  }, [token, roomName]);

  if (!isOnCall) return null

  return (
    <Draggable
      axis="both"
      handle=".window-control"
      defaultPosition={{x: -740, y: -321}}
      scale={1}
    >
      <ModalContainer>
        {room && (
          <>
        <WindowControl className="window-control" />
          <VideoCall room={room} isMicOn={isMicOn} isCameraOn={isCameraOn} agentName = {agentName} agentPhotoURL = {agentPhotoURL}/>
        <WindowControlBottom className="window-control" />
          </>
        )}
      </ModalContainer>
    </Draggable>
  )
}

export default ChatCall;
